import * as React from 'react';
import styled from 'styled-components';

import { DefaultInputStateCss, DisabledInputStateCss } from './sharedStyles';
import { colors } from '../colors/color';

export type SelectOption = {
    value: string,
    text: string,
    __innerHtml?:string
}

export type SelectOptionGroup = {
    text:string,
    options:SelectOption[]
}

export type SelectProps = {
    id?: string,
    selectedValue: string,
    options: (SelectOption | SelectOptionGroup)[],
    onChange: (newValue: string) => void,
    onFocus?: () => void,
    onBlur?: () => void,
    emptyText?: string,
    disabled?: boolean,
    width?:string,
    minWidth?:string
}
export function Select(props: SelectProps) {

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(event.target.value);
    };

    return (
        <StyledSelect
            id={props.id}
            value={props.selectedValue}
            onChange={handleChange}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            disabled={props.disabled}
            style={{minWidth:props.minWidth, width:props.width}}>
                <>
                    {props.emptyText !== undefined &&
                        <option value="">{props.emptyText}</option>
                    }

                    {props.options.map((option) =>{
                        if((option as SelectOptionGroup).options !== undefined){
                            const o = option as SelectOptionGroup;
                            return (
                                <optgroup key={o.text} label={o.text}>
                                    {o.options.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))}
                                </optgroup>
                            );
                        }
                        else{
                            const o = option as SelectOption;
                            
                            return o.__innerHtml 
                                ?
                                    <option key={o.value} value={o.value} dangerouslySetInnerHTML={{__html:o.__innerHtml}} />
                                :
                                    <option key={o.value} value={o.value}>
                                        {o.text}
                                    </option>
                        }
                })}
                </>

        </StyledSelect>
    );
}

const StyledSelect = styled.select`
    ${DefaultInputStateCss.base.container}
    ${DefaultInputStateCss.base.text}
    border-radius: 4px;
    font-size: 16px;
    padding: 10px 5px 10px 5px;
    width:100%;
    min-height: 44px;

    & * {
        background-color:${colors.background.white};
    }
    
    &:hover {
        ${DefaultInputStateCss.hover}
    }
    &:focus-visible {
        ${DefaultInputStateCss.focus}
    }
    &:active {
        ${DefaultInputStateCss.active}
    }
    &:disabled {
        ${DisabledInputStateCss.container}
        ${DisabledInputStateCss.text}
    }
`;